import { DEFAULT_PAGE_SIZE } from '../../model';

const ROW_HEIGHT = 275;
const MAX_COLUMN_WIDTH = 350;
const MIN_COLUMN_WIDTH = 250;
const DEFAULT_ASPECT_RATIO = 0.9;

export const DEFAULT_CONFIG = {
  // if this value is set, rowHeight vallue is ignored, and
  // the row height is calculated by columnWidth * aspectRatio
  aspectRatio: DEFAULT_ASPECT_RATIO,
  maxColumnWidth: MAX_COLUMN_WIDTH,
  minColumnWidth: MIN_COLUMN_WIDTH,
  rowHeight: ROW_HEIGHT,
  preferredCellsPerPage: DEFAULT_PAGE_SIZE,
};
